module.exports = (__webpack_require__(7793))(970);